<script lang="ts">
  import type { BoardCard } from '$lib/types';
  import { boardDate, boardDueState } from '$lib/utils/board';
  import { t } from '$lib/i18n';
  let { card }: { card: BoardCard } = $props();
  const state = $derived(boardDueState(card));
</script>

{#if card.due_date}
  <span class="mt-1.5 inline-flex rounded-full px-2 py-1 text-[11px] font-semibold {state === 'overdue' ? 'bg-red-50 text-red-700' : 'bg-surface-2 text-dark-gray'}">
    {state === 'overdue' ? t('board.due.overdue') : state === 'today' ? t('board.due.today') : t('board.due.label')} · {boardDate(card.due_date)}
  </span>
{/if}
